<div class="tile">

  <!-- Spinner while loading -->
  <ng-container *ngIf="!initialized">
    <div class="loading-container">
      <mat-spinner></mat-spinner>
    </div>
  </ng-container>

  <ng-container *ngIf="initialized">
    <div *ngIf="mode === UserBoardComponentMode.Edit" class="bottom-spacing">
      <div class="first-input-row">
        <!-- Header Input -->
        <mat-form-field class="w-full" appearance="fill">
          <mat-label>Chart Header</mat-label>
          <input matInput [(ngModel)]="model.header" />
        </mat-form-field>

        <!-- Dataset Selection -->
        <mat-form-field class="w-full" appearance="fill" *ngIf="datasets.length > 0">
          <mat-label>GroupBy Dataset</mat-label>
          <mat-select [(ngModel)]="model.groupBy.datasetId" (selectionChange)="onDatasetChange(model.groupBy.datasetId)">
            <mat-option *ngFor="let dataset of datasets" [value]="dataset.datasetReferenceTable.datasetId">
              {{ dataset.datasetReferenceTable.datasetName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Field to Display (conditionally shown) -->
        <mat-form-field class="w-full" appearance="fill" *ngIf="availableFields.length > 0">
          <mat-label>Field To Display</mat-label>
          <mat-select [(ngModel)]="model.groupBy.fieldToDisplay" (selectionChange)="onFieldChange($event.value)">
            <!-- Special option for PrimaryKey -->
            <mat-option *ngIf="showPrimaryKey()"
              [value]="getPrimaryKeyValue()">
              Primary Key
            </mat-option>

            <!-- Normal fields -->
            <mat-option *ngFor="let field of availableFields" [value]="field.fieldName">
              {{ field.fieldName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Add Metric Section -->
      <div class="space-y-2">
        <!-- Add Line Metric -->
        <div class="flex gap-4 items-end">
          <!-- Metric Selection -->
          <mat-form-field appearance="fill" class="flex-1">
            <mat-label>Add Line Metric</mat-label>
            <mat-select [(ngModel)]="selectedLineMetric">
              <mat-option *ngFor="let metric of availableMetrics" [value]="metric">
                {{ metric.metricName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Color Picker -->
          <mat-form-field appearance="fill">
            <mat-label>Color</mat-label>
            <input matInput type="color" [(ngModel)]="selectedLineColor" />
          </mat-form-field>

          <mat-form-field appearance="fill" class="flex-1">
            <mat-label>Solid/Dashed</mat-label>
            <mat-select [(ngModel)]="solidOrDashed">
              <mat-option *ngFor="let pick of ['Solid', 'Dashed']" [value]="pick">
                {{ pick }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Add Button -->
          <button mat-raised-button color="primary"
            (click)="onLineMetricAdd(selectedLineMetric, selectedLineColor, solidOrDashed)">
            Add
          </button>
        </div>

        <!-- Added Line Metrics -->
        <div class="flex flex-wrap gap-2">
          <button
            *ngFor="let chartMetric of model.lineMetrics; let i = index"
            mat-raised-button
            color="primary"
            class="flex items-center space-x-1"
          >
            <span>{{ chartMetric.metric.metricName }}</span>
            <mat-icon (click)="onMetricRemove(i, 'line')">close</mat-icon>
          </button>
        </div>

        <!-- Add Bar Metric -->
        <div class="flex gap-4 items-end">
          <!-- Metric Selection -->
          <mat-form-field appearance="fill" class="flex-1">
            <mat-label>Add Bar Metric</mat-label>
            <mat-select [(ngModel)]="selectedBarMetric">
              <mat-option *ngFor="let metric of availableMetrics" [value]="metric">
                {{ metric.metricName }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <!-- Color Picker -->
          <mat-form-field appearance="fill">
            <mat-label>Color</mat-label>
            <input matInput type="color" [(ngModel)]="selectedBarColor" />
          </mat-form-field>

          <!-- Add Button -->
          <button mat-raised-button color="primary"
            (click)="onBarMetricAdd(selectedBarMetric, selectedBarColor)">
            Add
          </button>

          <!-- Bar Stack Toggle-->
          <mat-slide-toggle color="primary" class="stack-button" [checked]="barsStacked" (change)="toggleStacked($event)">Stack Bars</mat-slide-toggle>

        </div>

        <!-- Added Bar Metrics -->
        <div class="flex flex-wrap gap-2">
          <button
            *ngFor="let chartMetric of model.barMetrics; let i = index"
            mat-raised-button
            color="primary"
            class="flex items-center space-x-1"
          >
            <span>{{ chartMetric.metric.metricName }}</span>
            <mat-icon (click)="onMetricRemove(i, 'bar')">close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- View Mode -->
    <ng-container *ngIf="chartData != null">
      <div *ngIf="mode === UserBoardComponentMode.Preview" class="preview-header">
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('edit')">edit</mat-icon>
        <mat-icon style="cursor: pointer" (click)="onPreviewButtonClick('delete')">delete</mat-icon>
      </div>
      <div *ngIf="model.header != null && model.header != ''" class="header-text">{{ model.header }}</div>
      <p-chart type="line" [data]="chartData" [options]="chartOptions" class="h-full w-full"/>
    </ng-container>
  </ng-container>
</div>
